import React, { useRef, useState, useCallback } from 'react';
import cn from 'classnames';
import ImgPreview from '../ImgPreview/ImgPreview';
import LightboxGroup from '../../../../components/LightboxGroup/LightboxGroup';
import styles from './ImagesGallery.module.scss';

const isFull = (isOdd, index, amount) => isOdd && index === amount - 1;

const ImagesGallery = ({
  className,
  images,
  queryUrl,
  queryParams,
  useImgQuery,
  queryOptions,
  queryFnData,
}) => {
  const length = images.length;
  const isOdd = length % 2 !== 0;

  const rootRef = useRef();

  const [showViewer, setShowViewer] = useState(false);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const handlePreviewClick = (index) => {
    setShowViewer(true);
    setCurrentImgIndex(index);
  };

  const handleViewerClose = useCallback(() => {
    setShowViewer(false);
    setCurrentImgIndex(0);
  }, []);

  return (
    <div
      className={cn(styles.root, className, {
        [styles.halfRoot]: length === 1,
      })}
      ref={rootRef}
    >
      {images.map((image, index) => (
        <ImgPreview
          imgData={image}
          key={image.id}
          containerRef={rootRef}
          onPreviewClick={() => handlePreviewClick(index)}
          className={cn({
            [styles.fullPreview]: isFull(isOdd, index, length),
            [styles.halfPreview]: !isFull(isOdd, index, length),
          })}
          useImgQuery={useImgQuery}
          queryOptions={queryOptions}
          queryFnData={queryFnData}
        />
      ))}
      <LightboxGroup
        visible={showViewer}
        onClose={handleViewerClose}
        attachments={images}
        attachment={images[currentImgIndex]}
        url={queryUrl}
        params={
          typeof queryParams === 'function'
            ? queryParams(images[currentImgIndex])
            : queryParams
        }
        imageParamField="fileName"
      />
    </div>
  );
};

export default ImagesGallery;
